import { action } from "typesafe-actions";

import { message } from "antd";

import { GatePayload } from "../../common_types";
import { IntervalPayload } from "../types";

import { ApiStateResponse, ApiStateWidgetActionTypes } from "./types";

export const fetchRequest = (payload: GatePayload & IntervalPayload) =>
  action(ApiStateWidgetActionTypes.FETCH_REQUEST, payload);

export const fetchSuccess = (payload: ApiStateResponse) => action(ApiStateWidgetActionTypes.FETCH_SUCCESS, payload);

export const fetchError = (errorMessage: string) => {
  message.error(errorMessage);
  return action(ApiStateWidgetActionTypes.FETCH_ERROR);
};
